<template>
  <div class="parent" v-bind:class="{ 'full': isActive }">  
    <div class="child childA"><img src="@/assets/espa-2021-2027.svg" alt=""></div>
    <div class="child childB"><img src="@/assets/eldi-ypekky.svg" alt=""></div>
    <div class="child childC">
      <p>
        ΔΡΑΣΗ «ΠΡΟΩΘΗΣΗ ΚΑΙ ΥΠΟΣΤΗΡΙΞΗ ΠΑΙΔΙΩΝ ΓΙΑ ΤΗΝ ΕΝΤΑΞΗ ΤΟΥΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΕΚΠΑΙΔΕΥΣΗ ΚΑΘΩΣ 
        ΚΑΙ ΓΙΑ ΤΗ ΠΡΟΣΒΑΣΗ ΠΑΙΔΙΩΝ ΣΧΟΛΙΚΗΣ ΗΛΙΚΙΑΣ, ΕΦΗΒΩΩΝ ΚΑΙ ΑΤΟΜΩΝ ΜΕ ΑΝΑΠΗΡΙΑ ΣΕ ΥΠΗΡΕΣΙΕΣ ΔΗΜΙΟΥΡΓΙΚΗΣ ΑΠΑΣΧΟΛΗΣΗΣ»
      </p>
      
      </div>
    <div class="child childD"><img src="@/assets/flag-europe-europian-cash-otl.svg" alt=""></div>
</div>

</template>

<script>

export default {
    data(){
        return{
            isActive: true
        }
    },
    computed:{
        isAuthenticated(){
            return  this.$store.getters.isAuthenticated;
        },
    },
     created(){
         if(this.isAuthenticated){
             this.isActive = false;
         }
     }
};
</script>

<style lang="scss" scoped>

.parent {
  display: flex;
  margin: 2rem;

  .child {
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.8rem;
    p{
      font-size: 0.75rem;
       margin: 0;
    }
    img{
      max-height: 55px;
    }
   
  }

  .childA {
    min-width:  1%;
    // flex: 1;
    // background-color: turquoise;
  }

  .childB {
    min-width:  1%;
    // flex: 1;
    // background-color: wheat;
  }

  .childC {
    flex: 1;
    width: 97%;
    // background-color: blueviolet;
  }

   .childD {
   min-width:  1%;
    // flex: 1;
    // background-color: blueviolet;
  }
}

.row.banner {
    padding: 0.25rem;
    background-color: transparent;
    margin: 0 auto;

    &.full{
         width: 100%;
        //margin-left: -20%;
    }
   

    div[class^="col-md-"] {
      height: 100px;
      display: flex;
      align-items: center;
      font-size: 0.55rem;
      padding: 0 5px;

      .text {
        padding: 5px;
      }
    }

    img {
      max-width: 100%;
      vertical-align: middle;
    }
  }

@media (max-width: 767px) {
  .row.banner {
    padding: 0.25rem 4rem;
    background-color: transparent;
    margin: 0 auto;
    
    &.full{
         width: 120%;
        margin-left: -10%;
    }

    div[class^="col-md-"] {
      height: 100px;
      display: flex;
      align-items: center;
      font-size: 0.55rem;
      padding: 0 5px;

      .text {
        padding: 5px;
      }
    }

    img {
      max-width: 100%;
      vertical-align: middle;
    }
  }
.parent {
  display: block;
  margin: 2rem auto;
float: left;
  .child {
    height: auto;
    display: block;
    align-items: center;
    padding: 0.3rem;
    float: left;
    clear: both;
    p{
      font-size: 0.75rem;
       margin: 0;
    }
    img{
      max-height: 55px;
    }
   
  }

  .childA, .childB ,.childC,.childD {
    flex: unset;
    display: block;
    width:  100%;
    float:left;
  }

}

}
@media (min-width: 768px) {
  .parent{
    margin: 3rem auto;
    padding: 0 3rem;
  }
  .row.banner {
    padding: 0.25rem 4rem;
    background-color: transparent;
    margin: 0 auto;


    div[class^="col-md-"] {
      height: 100px;
      display: flex;
      align-items: center;
      font-size: 0.75rem;
      padding: 0 10px;

      .text {
        padding: 15px;
      }
    }

    img {
      max-width: 90%;
      vertical-align: middle;
    }
  }
}

@media (max-width: 1024px) {
.parent{
    margin: 3rem auto;
    width: 100%;
    margin-left: 0;
  }
}

</style>